
// React import removed as not used directly (JSX transform)

export const Logo = ({ className }: { className?: string }) => {
    return (
        <span className={className} style={{maskImage: `url(https://cdn.dashbal.com/assets/icon_21dc22b7.svg)`, WebkitMaskImage: `url(https://cdn.dashbal.com/assets/icon_21dc22b7.svg)`, maskRepeat: 'no-repeat', WebkitMaskRepeat: 'no-repeat', maskPosition: 'center', WebkitMaskPosition: 'center', maskSize: 'contain', WebkitMaskSize: 'contain', backgroundColor: 'currentColor', display: 'inline-block'}} role='img' />
    );
};
